import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface SampleType {
  id: number;
  number: string;
  name: string;
  description?: string;
  accommodationCount: string;
}

const fetchSampleTypes = async (): Promise<SampleType[]> => {
  try {
    const { data } = await api.get<SampleType[]>('/api/sample-types');
    console.log('API Response:', data); // Debug log
    return data;
  } catch (error) {
    console.error('Error fetching sample types:', error); // Debug log
    throw new Error('Error al cargar los tipos de muestra');
  }
};

export const useSampleTypes = () => {
  const { data: sampleTypes = [], isLoading, error } = useQuery({
    queryKey: ['sampleTypes'],
    queryFn: fetchSampleTypes,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: 3,
  });

  return { sampleTypes, isLoading, error };
}; 